(function() {
  'use strict';

  angular.module('app.tracts')
    .factory('tracts', tracts);

  function tracts($http, $q, $uibModal, $templateCache, $filter, esriLoader, esriRegistry, fieldDomains, maps, Reports, Loader, $rootScope, appConfig) {
    let tractsLayer,
      parcelsLayer,
      exportDrawToolbar,
      selectedFeatures,
      fields,
      allTracts;

    let service = {
      list: list,
      setupDrawingToolbar: setupDrawingToolbar,
      setLayer: setLayer,
      getLayer: getLayer,
      getTracts: getTracts,
      startDrawingTool: startDrawingTool,
      stopDrawing: stopDrawing,
      deleteTract: deleteTract,
      submitTractAttachment: submitTractAttachment,
      update: update,
      updateComments: updateComments,
      updatePricesOnly: updatePricesOnly,
      _calcNextId: _calcNextId,
      _unionGeometry: _unionGeometry,
      getAllPins: getAllPins,
      getAllLotNums: getAllLotNums,
      getAllJudgementYrs: getAllJudgementYrs,
      getAllForfeitDates: getAllForfeitDates,
      _calcCentroidAndLinks: _calcCentroidAndLinks,
      _saveNewTract: _saveNewTract,
      updateAll: updateAll,
      archiveAndDelete: archiveAndDelete,
      updateTract: updateTract
    };

    return service;

    // return a list of call parcels in the tax forfeit feature service
    function list(query, count) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request'
      ], function(
        esriRequest
      ) {
        console.log('tracts list ', query);
        if (count > 0) {
          let requestHandle = esriRequest({
            'url': appConfig.getConfig().tractsUrl + '/query',
            'content': {
              'f': 'json',
              'where': query,
              'inSR': 102100,
              'outFields': '*',
              'returnGeometry': false
            },
            'handleAs': 'json',
            'callbackParamName': 'callback'
          });
          requestHandle.then(function(results) {
            console.log('Number of tracts = ', results.features.length);
            allTracts = results.features;
            $rootScope.$broadcast('tracts-changed', allTracts);
            d.resolve('done');
          }, function(err) {
            console.error(err);
          });
        } else {
          allTracts = [];
          $rootScope.$broadcast('tracts-changed', allTracts);
          d.resolve('done');
        }

      });
      return d.promise;
    }

    function setupDrawingToolbar() {
      esriRegistry.get('adminMap').then(function(map) {
        esriLoader.require([
          'esri/toolbars/draw',
          'esri/tasks/query',
          'esri/tasks/QueryTask',
          'esri/layers/FeatureLayer',
          'esri/Color',
          'esri/symbols/SimpleFillSymbol',
          'esri/symbols/SimpleLineSymbol',
          'esri/SpatialReference'
        ], function(
          Draw,
          Query,
          QueryTask,
          FeatureLayer,
          Color,
          SimpleFillSymbol,
          SimpleLineSymbol,
          SpatialReference
        ) {
          // feature selection symbol
          // let polygonDrawSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_SOLID,
          //   new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
          //     new Color([255, 255, 0]), 4),
          //   new Color([255, 255, 255, 0.8])
          // );

          // set the tooltip for the draw tooltip
          esri.bundle.toolbars.draw.freehand = 'Press down to start and let go to finish selecting parcels you would like to be grouped together into a tract';

          //create the draw toolbar
          exportDrawToolbar = new Draw(map, {
            tooltipOffset: 20,
            showTooltips: true
          });

          // attach the field domains
          fieldDomains.initialize(appConfig.getConfig()).then(function(results) {
            fields = results;
          });

          // connect the draw end handle
          exportDrawToolbar.on('draw-complete', function(event) {
            // deactivate the draw tool
            exportDrawToolbar.deactivate();
            // setup the spatial query on timber Sales
            let exportSelection = new Query();
            exportSelection.geometry = event.geometry;
            exportSelection.outFields = ['*'];
            // TODO: CWCT-684
            exportSelection.where = 'TaxForfeitedStatus = \'Active\'';
            exportSelection.returnGeometry = true;
            exportSelection.spatialRelationship = Query.SPATIAL_REL_INTERSECTS;
            exportSelection.outSpatialReference = new SpatialReference(102100);
            // select the parcels
            var queryTask = new QueryTask(parcelsLayer.url);
            queryTask.execute(exportSelection, function(selFeatures) {
              stopDrawing();
              $rootScope.$broadcast('done-with-tracts');
              selectedFeatures = selFeatures.features;
              _newTractDialog();
            }, function(error) {
              console.error('ERROR selecting features: ', error);
            });
            // parcelsLayer.setSelectionSymbol(polygonDrawSymbol);
            // parcelsLayer.selectFeatures(exportSelection, FeatureLayer.SELECTION_NEW);
            // parcelsLayer.setSelectionSymbol(null);
          }); // end draw toolbar handler
        });
      });
    }

    // set the tracts layer
    function setLayer(theTracts, parcels) {
      tractsLayer = theTracts;
      parcelsLayer = parcels;
    }

    // return the selected tracts
    function getTracts() {
      return allTracts;
    }

    // return the tracts layer to be used anywhere in the app
    function getLayer() {
      return tractsLayer;
    }

    function startDrawingTool() {
      esriLoader.require([
        'esri/toolbars/draw'
      ], function(
        Draw
      ) {
        // active the draw toolbar
        exportDrawToolbar.activate(Draw.EXTENT);
      });
    }

    function stopDrawing() {
      exportDrawToolbar.deactivate();
    }

    function deleteTract(objectid) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request'
      ], function(
        esriRequest
      ) {
        console.log('request url: ', appConfig.getConfig().tractsUrl);
        console.log('request oid: ', objectid);
        let requestHandle = esriRequest({
          'url': appConfig.getConfig().tractsUrl + '/applyEdits',
          'content': {
            'f': 'json',
            'deletes': objectid
          },
          'handleAs': 'json',
          'usePost': true,
          'callbackParamName': 'callback'
        }, {
          usePost: true
        });
        requestHandle.then(function(results) {
          console.log('tract deleted! ', results);
          maps.refreshDynamicLayer();
          d.resolve(results);
        }, function(results) {
          console.log('error', results);
        });
      });
      return d.promise;
    }

    function update(tracts) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request',
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        esriRequest,
        Query,
        QueryTask
      ) {
        let tractFeatures = [];
        let tractIds = [];
        // console.log(tracts);
        for (let id in tracts) {
          if (tracts[id].attributes.Tract != null) {
            tractIds.push('\'' + tracts[id].attributes.Tract + '\'');
          }
        }

        // get the associated ids for the tracts needing updating
        let query = new Query();
        query.where = 'Tract IN (' + tractIds.join(',') + ')';
        // query.returnGeometry = false;
        // query.outFields = ['*'];
        // console.log(query.where);
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        queryTask.executeForIds(query, function(results) {
          // console.log(results);
          if (results != null) {
            for (let i = 0; i < results.length; i++) {
              let oneTract = {
                attributes: {
                  OBJECTID: results[i],
                  Last_LS_date: tracts[0].attributes.Last_LS_date // jshint ignore:line
                }
              };
              tractFeatures.push(oneTract);
            }

            let requestHandle = esriRequest({
              'url': appConfig.getConfig().tractsUrl + '/applyEdits',
              'content': {
                'f': 'json',
                'updates': JSON.stringify(tractFeatures)
              },
              'handleAs': 'json',
              'usePost': true,
              'callbackParamName': 'callback'
            }, {
              usePost: true
            });
            requestHandle.then(function(results) {
              d.resolve(results);
            }, function(results) {
              console.log('error', results);
            });
          } else {
            d.resolve('no tracts to update');
          }
          // console.log(tractFeatures);
          // d.resolve('done');
        });
        // scrub out the date fields
        // _formatFeature(parcel);
        // let submitFeature = {attributes: {}};
        // submitFeature.attributes = parcel.attributes;
        // console.log(parcel);
      });
      return d.promise;
    }


    function updateComments(tractId, comments) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request',
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        esriRequest,
        Query,
        QueryTask
      ) {
        // get the associated ids for the tracts needing updating
        let query = new Query();
        query.where = 'Tract = \'' + tractId + '\'';
        query.returnGeometry = false;
        query.outFields = ['*'];
        // console.log(query.where);
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        queryTask.execute(query, function(results) {
          // console.log('associated tract: ', results.features[0], 'Price = ', price);
          if (results != null) {
            let oneTract = {
              attributes: {
                OBJECTID: results.features[0].attributes.OBJECTID,
                m_comments: comments
              }
            };
            let requestHandle = esriRequest({
              'url': appConfig.getConfig().tractsUrl + '/applyEdits',
              'content': {
                'f': 'json',
                'updates': JSON.stringify([oneTract])
              },
              'handleAs': 'json',
              'usePost': true,
              'callbackParamName': 'callback'
            }, {
              usePost: true
            });
            requestHandle.then(function(results) {
              d.resolve('tract updated ', results);
            }, function(results) {
              console.log('error', results);
            });
          } else {
            d.resolve('no tracts to update');
          }
          // console.log(tractFeatures);
          // d.resolve('done');
        });
        // scrub out the date fields
        // _formatFeature(parcel);
        // let submitFeature = {attributes: {}};
        // submitFeature.attributes = parcel.attributes;
        // console.log(parcel);
      });
      return d.promise;
    }

    function updatePricesOnly(tractId, landPriceDif, timberPriceDif, impPriceDif, specPriceDif, priceDif) {
      // console.log('updatePricesOnly ', tractId, landPriceDif, timberPriceDif, impPriceDif, specPriceDif, priceDif);
      let d = $q.defer();
      esriLoader.require([
        'esri/request',
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        esriRequest,
        Query,
        QueryTask
      ) {
        // get the associated ids for the tracts needing updating
        let query = new Query();
        query.where = 'Tract = \'' + tractId + '\'';
        query.returnGeometry = false;
        query.outFields = ['*'];
        // console.log(query.where);
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        queryTask.execute(query, function(results) {
          // console.log('associated tract: ', results.features[0], 'Land_price dif = ', landPriceDif);
          if (results != null) {
            let oneTract = {
              attributes: {
                OBJECTID: results.features[0].attributes.OBJECTID,
                Land_price: results.features[0].attributes.Land_price + landPriceDif,
                Timber_price: results.features[0].attributes.Timber_price + timberPriceDif,
                Imp_price: results.features[0].attributes.Imp_price + impPriceDif,
                Special_price: results.features[0].attributes.Special_price + specPriceDif,
                Start_bid_price: results.features[0].attributes.Start_bid_price + priceDif

              }
            };
            let requestHandle = esriRequest({
              'url': appConfig.getConfig().tractsUrl + '/applyEdits',
              'content': {
                'f': 'json',
                'updates': JSON.stringify([oneTract])
              },
              'handleAs': 'json',
              'usePost': true,
              'callbackParamName': 'callback'
            }, {
              usePost: true
            });
            requestHandle.then(function(results) {
              d.resolve('tract updated ', results);
            }, function(results) {
              console.log('error', results);
            });
          } else {
            d.resolve('no tracts to update');
          }
          // console.log(tractFeatures);
          // d.resolve('done');
        });
        // scrub out the date fields
        // _formatFeature(parcel);
        // let submitFeature = {attributes: {}};
        // submitFeature.attributes = parcel.attributes;
        // console.log(parcel);
      });
      return d.promise;
    }

    // more generic tract update function
    function updateTract(tractId, updatedTract) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request',
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        esriRequest,
        Query,
        QueryTask
      ) {
        // get the associated ids for the tracts needing updating
        let query = new Query();
        query.where = 'Tract = \'' + tractId + '\'';
        query.returnGeometry = false;
        query.outFields = ['*'];
        // console.log(query.where);
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        queryTask.execute(query, function(results) {
          // console.log('tract to update: ', results.features);
          if (results != null) {
            let oneTract = {
              attributes: {
                OBJECTID: results.features[0].attributes.OBJECTID
              }
            };
            for (var key in updatedTract.attributes) {
              if (updatedTract.attributes.hasOwnProperty(key)) {
                // console.log(key + ' -> ' + updatedTract.attributes[key]);
                if (updatedTract.attributes[key] !== 0) {
                  // console.log('key: ', key);
                  oneTract.attributes[key] = results.features[0].attributes[key] + updatedTract.attributes[key];
                }
              }
            }
            console.log('---------- Tract prices -----------');
            console.log('Starting bid price: ', results.features[0].attributes.Start_bid_price);
            console.log('Land Price: ', results.features[0].attributes.Land_price);
            console.log('Timber Price: ', results.features[0].attributes.Timber_price);
            console.log('Improvement Price', results.features[0].attributes.Imp_price);
            console.log('Special Assessment Price: ', results.features[0].attributes.Special_price);
            console.log('----------------------------------------');
            console.log('update tract: ', oneTract.attributes);
            let requestHandle = esriRequest({
              'url': appConfig.getConfig().tractsUrl + '/applyEdits',
              'content': {
                'f': 'json',
                'updates': JSON.stringify([oneTract])
              },
              'handleAs': 'json',
              'usePost': true,
              'callbackParamName': 'callback'
            }, {
              usePost: true
            });
            requestHandle.then(function(results) {
              d.resolve('tract updated ', results);
            }, function(results) {
              console.log('error', results);
            });
          } else {
            d.resolve('no tracts to update');
          }
          // console.log(tractFeatures);
          // d.resolve('done');
        });
      });
      return d.promise;
    }

    // Update all tracts and parcels with the template passed in
    function updateAll(bulkTract, selected, selField) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request'
      ], function(
        esriRequest
      ) {
        // start the parcel loading query
        // scrub out the date fields
        let bulkTracts = _formatBulkFeatures(bulkTract, selected, selField);
        // console.log(bulkTracts);
        if (bulkTracts.length === 0) {
          return;
        }
        let requestHandle = esriRequest({
          'url': appConfig.getConfig().tractsUrl + '/applyEdits',
          'content': {
            'f': 'json',
            'updates': JSON.stringify(bulkTracts)
          },
          'handleAs': 'json',
          'usePost': true,
          'callbackParamName': 'callback'
        }, {
          usePost: true
        });
        requestHandle.then(function(results) {
          $rootScope.$broadcast('tracts-changed', allTracts);
          d.resolve(results.updateResults);
        }, function(results) {
          d.resolve('error');
          alert('Error saving bulk ');
          $rootScope.$broadcast('tracts-changed', allTracts);
          console.log('error', results);
        });
      });
      return d.promise;
    }

    function archiveAndDelete(tractId, closeout) {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask',
        'esri/request'
      ], function(
        Query,
        QueryTask,
        esriRequest
      ) {
        // console.log(appConfig.getConfig().tractsHistoryUrl);
        let query = new Query();
        query.returnGeometry = false;
        query.outFields = ['*'];
        query.where = 'Tract = \'' + tractId + '\'';
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        queryTask.execute(query, function(results) {
          let feature = results.features[0];
          console.log('Tract to archive: ', feature);
          // delete the unique ID fields from the original tract record
          if (feature != null) {
            feature.attributes.Purch_price = closeout.PurchasedPrice;
            if (closeout.PurchaseDate != null) {
              if (closeout.PurchaseDate.date != null) {
                feature.attributes.PurchaseDate = _formatDataBaseDate(_formatDate(closeout.PurchaseDate.date));
              } else {
                feature.attributes.PurchaseDate = null;
              }
            }
            feature.attributes.Sold_type = closeout.Sold_type;
            let objId = feature.attributes.OBJECTID;
            delete feature.attributes.OBJECTID;
            // console.log('historical record: ', feature);
            // console.log('delete tract: ', objId);
            // FIXME: doesn't seem to save.....
            // feature.attributes.relGUID = feature.attributes.GlobalID;
            delete feature.attributes.GlobalID;
            // d.resolve({status: 'done'});
            // archive the tract in the tracts history table
            let requestHandle = esriRequest({
              'url': appConfig.getConfig().tractsHistoryUrl + '/applyEdits',
              'content': {
                'f': 'json',
                'adds': JSON.stringify([feature])
              },
              'handleAs': 'json',
              'usePost': true,
              'callbackParamName': 'callback'
            }, {
              usePost: true
            });
            requestHandle.then(function() {
              console.log('Added tract to archive table. Deleting objId: ', objId);
              deleteTract(objId).then(function(delResults) {
                d.resolve(delResults);
              }, function(errorResults) {
                alert('Error deleting tract from the tracts feature class. ', errorResults.error);
                console.log('error', errorResults);
              });
            }, function(results) {
              d.resolve('error');
              alert('Error archiving tract');
              console.log('error', results);
            });
          } else {
            d.resolve('no tract');
          }
        });
      });
      return d.promise;
    }

    function _newTractDialog() {
      // union the geometries together
      // console.log(selectedFeatures);
      if (selectedFeatures.length > 0) {
        // let modalInstance =
        $uibModal.open({
          animation: true,
          template: $templateCache.get('modules/tracts/createTract.html'),
          controller: 'CreateTractCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            message: function() {
              return 'Create a new tract';
            },
            totalPrice: function() {
              return calculatePrice();
            },
            totalAcres: function() {
              return calculateAcres();
            },
            totalLandValue: function() {
              return calculateLandValue();
            },
            totalBldgsValue: function() {
              return calculateBldgsValue();
            },
            totalTimberValue: function() {
              return calculateTimberValue();
            },
            totalAssessments: function() {
              return calculateAssessments();
            },
            nearestCity: function() {
              return selectedFeatures[0].attributes.NearestCity != null ? selectedFeatures[0].attributes.NearestCity : '';
            },
            politicalSub: function() {
              return calculatePolSub();
            },
            firstParcelData: function() {
              return getFirstParcelData();
            },
            domains: function() {
              return fields;
            },
            tract: function() {
              return getNextId();
            },
            pictures: function() {
              return getAttachments();
            },
            comments: function() {
              return getAllComments();
            },
            selectedFeatures: function() {
              return selectedFeatures;
            }
          }
        });
      } else {
        alert('Please select parcels to create tracts.');
      }
    }

    // calculate the price of the tract based on the prices of each parcel
    function calculatePrice() {
      let parcels = selectedFeatures;
      let totalParcelPrice = 0;
      for (let i = 0; i < parcels.length; i++) {
        totalParcelPrice += parcels[i].attributes.Land_price; // jshint ignore:line
        totalParcelPrice += parcels[i].attributes.Imp_price; // jshint ignore:line
        totalParcelPrice += parcels[i].attributes.Special_price; // jshint ignore:line
      }
      return Math.round(totalParcelPrice * 100) / 100;
    }

    // calculate total land value of tract
    function calculateLandValue() {
      let parcels = selectedFeatures;
      let totalLandValue = 0;
      for (let i = 0; i < parcels.length; i++) {
        totalLandValue += parcels[i].attributes.Land_price; // jshint ignore:line
      }
      return Math.round(totalLandValue * 100) / 100;
    }

    // calculate total value of buildings
    function calculateBldgsValue() {
      let parcels = selectedFeatures;
      let totalBldgs = 0;
      for (let i = 0; i < parcels.length; i++) {
        totalBldgs += parcels[i].attributes.Imp_price; // jshint ignore:line
      }
      return Math.round(totalBldgs * 100) / 100;
    }

    // calculate total value of timber
    function calculateTimberValue() {
      let parcels = selectedFeatures;
      let totalTimber = 0;
      for (let i = 0; i < parcels.length; i++) {
        totalTimber += parcels[i].attributes.Timber_price; // jshint ignore:line
      }
      return Math.round(totalTimber * 100) / 100;
    }
    // calculate total special assessments
    function calculateAssessments() {
      let parcels = selectedFeatures;
      let totalAssessments = 0;
      for (let i = 0; i < parcels.length; i++) {
        totalAssessments += parcels[i].attributes.Special_price; // jshint ignore:line
      }
      return Math.round(totalAssessments * 100) / 100;
    }

    // calculate the total acres of the selected parcels
    function calculateAcres() {
      let parcels = selectedFeatures;
      let totalAcres = 0;
      for (let i = 0; i < parcels.length; i++) {
        totalAcres += parcels[i].attributes.Acres;
      }
      return Math.round(totalAcres * 100) / 100;
    }

    // get the political subdivision to attach to the tract
    function calculatePolSub() {
      getDomainValue('Political_Sub', selectedFeatures[0].attributes.Political_Sub); // jshint ignore:line
      return getDomainValue('Political_Sub', selectedFeatures[0].attributes.Political_Sub); // jshint ignore:line
    }

    // return an object with the first parcel's information
    function getFirstParcelData() {
      let firstParcel = {
        attributes: {}
      };
      firstParcel.attributes.PhysAddr = selectedFeatures[0].attributes.PhysAddr;
      firstParcel.attributes.PhysCity = selectedFeatures[0].attributes.PhysCity;
      firstParcel.attributes.PhysZip = selectedFeatures[0].attributes.PhysZip;
      firstParcel.attributes.StructurePresent = selectedFeatures[0].attributes.StructurePresent;
      firstParcel.attributes.PIN = selectedFeatures[0].attributes.PIN;
      firstParcel.attributes.Last_LS_date = selectedFeatures[0].attributes.Last_LS_date; // jshint ignore:line
      firstParcel.attributes.Last_LS_date = selectedFeatures[0].attributes.Last_LS_date; // jshint ignore:line
      firstParcel.attributes.Block = selectedFeatures[0].attributes.Block;
      firstParcel.attributes.Sec = selectedFeatures[0].attributes.Sec;
      firstParcel.attributes.Twp = selectedFeatures[0].attributes.Twp;
      firstParcel.attributes.Rnge = selectedFeatures[0].attributes.Rnge;
      firstParcel.attributes.Legals = selectedFeatures[0].attributes.Legals;
      firstParcel.attributes.PlatDesc = selectedFeatures[0].attributes.PlatDesc; // jshint ignore:line

      return firstParcel;
    }

    // return array of all the parcel pins for the tract
    function getAllPins() {
      let allPins = [];
      for (let i = 0; i < selectedFeatures.length; i++) {
        allPins.push(selectedFeatures[i].attributes.PIN);
      }
      return allPins.join(', ');
    }

    function getAllComments() {
      let allComments = [];
      for (let i = 0; i < selectedFeatures.length; i++) {
        allComments.push(selectedFeatures[i].attributes.m_comments);
      }
      return allComments.join('\n');
    }

    // return array of lake #s for the tract
    // function getLakeNumbers() {
    //   let lakeNumbers = [];
    //   for (let i = 0; i < selectedFeatures.length; i++) {
    //     if (selectedFeatures[i].attributes.LakeNumber) {
    //       lakeNumbers.push(selectedFeatures[i].attributes.LakeNumber);
    //     }
    //   }
    //   return lakeNumbers.join(', ');
    // }

    // return array of lot #s for the tract
    function getAllLotNums() {
      let allLots = [];
      for (let i = 0; i < selectedFeatures.length; i++) {
        if (selectedFeatures[i].attributes.Lot != null) {
          allLots.push(selectedFeatures[i].attributes.Lot);
        }
      }
      return allLots.join(', ');
    }

    function getAllJudgementYrs() {
      let allYears = [];
      for (let i = 0; i < selectedFeatures.length; i++) {
        if (selectedFeatures[i].attributes.Judgement_Year != null) {
          allYears.push(selectedFeatures[i].attributes.Judgement_Year);
        }
      }
      return allYears.join(', ');
    }

    // FIXME: doesn't account for multiple different forfeiture dates
    function getAllForfeitDates() {
      let allDates = [];
      for (let i = 0; i < selectedFeatures.length; i++) {
        if (selectedFeatures[i].attributes.Forfeiture_date != null) {
          let aucDate = Reports._formatEsriDate(selectedFeatures[i].attributes.Forfeiture_date);
          aucDate = Reports._formatDate(aucDate);
          allDates.push(aucDate);
        }
      }
      return allDates.join(', ');
    }

    // combine the geometries to comprise a tract
    function _unionGeometry() {
      let parcels = selectedFeatures;
      let d = $q.defer();
      esriLoader.require([
        'esri/geometry/geometryEngine',
        'esri/tasks/GeometryService',
        'esri/tasks/ProjectParameters',
        'esri/SpatialReference'
      ], function(
        geometryEngine,
        GeometryService,
        ProjectParameters,
        SpatialReference
      ) {

        let allGeometries = [];
        for (let i = 0; i < parcels.length; i++) {
          allGeometries.push(parcels[i].geometry);
        }
        // combine the geometries
        let unionedGeometry = geometryEngine.union(allGeometries);
        // project the geometry to Crow Wing CO coordinates
        let gsvc = new GeometryService(appConfig.getConfig().geometryService);
        let params = new ProjectParameters();
        params.geometries = [unionedGeometry];
        params.outSR = new SpatialReference(103725);
        // params.transformation = ;
        gsvc.project(params, function(result) {
          d.resolve(result[0]);
        });
      });
      return d.promise;
    }

    function _saveNewTract(attributes, geometry, image) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request'
      ], function(
        esriRequest
      ) {
        // scrub out the date fields
        let newTract = _createTract(attributes, geometry);
        let requestHandle = esriRequest({
          'url': appConfig.getConfig().tractsUrl + '/applyEdits',
          'content': {
            'f': 'json',
            'adds': JSON.stringify([newTract])
          },
          'handleAs': 'json',
          'usePost': true,
          'callbackParamName': 'callback'
        }, {
          usePost: true
        });
        requestHandle.then(function(results) {
          console.log('new tract saved! ', results.addResults[0].objectId);
          let attachObjectId = results.addResults[0].objectId;
          // add the image attachment to the newly created tract
          if (image != null) {
            _addTractAttachment(attachObjectId, image);
          }
          _updateParcels(newTract.attributes.Tract, newTract.attributes.ProposedSaleType, newTract.attributes.Last_LS_date, newTract.attributes.m_comments).then(function() { // jshint ignore:line
            _refreshLayers();
            d.resolve(newTract);
          });
        }, function(results) {
          d.resolve('error');
          console.log('error', results);
        });
      });
      return d.promise;
    }

    function _createTract(attributes, geometry) {
      let newFeature = {};
      attributes.Political_Sub = attributes.Political_Sub.code; // jshint ignore:line
      if (attributes.Last_LS_date.date != null) { // jshint ignore:line
        attributes.Last_LS_date = _formatDataBaseDate(_formatDate(attributes.Last_LS_date.date)); // jshint ignore:line
      } else {
        attributes.Last_LS_date = null; // jshint ignore:line
      }
      newFeature.geometry = geometry;
      newFeature.attributes = attributes;
      return newFeature;
    }

    function _updateParcels(tractNumber, proposedSaleType, lastLsDate, m_comments) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request'
      ], function(
        esriRequest
      ) {
        // scrub out the date fields
        let updatedFeatures = _processFeatures(tractNumber, proposedSaleType, lastLsDate, m_comments);
        // console.log(updatedFeatures);
        let requestHandle = esriRequest({
          'url': appConfig.getConfig().parcelsUrl + '/applyEdits',
          'content': {
            'f': 'json',
            'updates': JSON.stringify(updatedFeatures)
          },
          'handleAs': 'json',
          'usePost': true,
          'callbackParamName': 'callback'
        }, {
          usePost: true
        });
        requestHandle.then(function(results) {
          console.log('parcels updated! ', results);
          Loader.enable();
          d.resolve(results);
        }, function(results) {
          console.log('error', results);
        });
      });
      return d.promise;
    }

    function getNextId() {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        let queryUrl = maps.getFilterLayer();
        let twoDigYear = new Date().getFullYear().toString().substr(-2);
        let query = new Query();
        query.where = 'Tract LIKE \'%-' + twoDigYear + '%\'';
        query.returnGeometry = false;
        query.outFields = ['Tract'];
        let queryTask = new QueryTask(queryUrl.url);
        queryTask.execute(query, function(results) {
          let features = results.features;
          d.resolve(_calcNextId(features, twoDigYear));
        });
      });
      return d.promise;
    }

    function _calcNextId(features, twoDigYear) {
      let tractNumbers = [];
      for (let i = 0; i < features.length; i++) {
        if (features[i].attributes.Tract.indexOf('-') > 0) {
          let trimmedNum = features[i].attributes.Tract.slice(0, -3);
          // console.log(trimmedNum);
          tractNumbers.push(parseInt(trimmedNum));
        }
      }

      // next tract number to assign for the year
      let nextNumber = 1;
      if (tractNumbers.length > 0) {
        nextNumber = Math.max.apply(null, tractNumbers) + 1;
      }
      // console.log(nextNumber);
      if (nextNumber.toString().length === 1) {
        return ('00' + nextNumber + '-' + twoDigYear);
      } else if (nextNumber.toString().length === 2) {
        return ('0' + nextNumber + '-' + twoDigYear);
      } else {
        return (nextNumber + '-' + twoDigYear);
      }
    }

    function getAttachments() {
      let d = $q.defer();
      let attachQueries = _allPromises(selectedFeatures);
      attachQueries.then(function(results) {
        // process the array of arrays to a single array
        let allAttachments = [];
        for (let i = 0; i < results.length; i++) {
          for (let z = 0; z < results[i].length; z++) {
            allAttachments.push(results[i][z]);
          }
        }
        d.resolve(allAttachments);
      });
      return d.promise;
    }

    function _allPromises(features) {
      let promises = [];
      for (let i = 0; i < features.length; i++) {
        // query each property to get the images from the attachments
        promises.push(parcelsLayer.queryAttachmentInfos(features[i].attributes.OBJECTID));
      }
      return $q.all(promises);
    }

    // add the attachment from the parcels to the newly created tract
    function _addTractAttachment(objectid, image) {
      // convert the URL into an html form element for submission to the add attachment function
      getBlob(image).then(function(imageBlob) {
        let form = _createFormElement(imageBlob, image.name);
        submitTractAttachment(objectid, form);
      });
    }

    function getBlob(image) {
      let d = $q.defer();
      var xhr = new XMLHttpRequest();
      xhr.open('GET', image.url, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (this.status === 200) {
          let myBlob = this.response;
          d.resolve(myBlob);
        }
      };
      xhr.send();
      return d.promise;
    }

    // function to convert an image url into a virtual html form element for submitting an image as an attachment to a tract
    function _createFormElement(image, imageName) {
      let formData = new FormData();
      formData.append('attachment', image, imageName);
      // console.log('worked! ', formData);
      return formData;
    }

    function submitTractAttachment(objectId, form) {
      esriLoader.require([
        'esri/request',
        'esri/layers/FeatureLayer'
      ], function(
        esriRequest,
        FeatureLayer
      ) {
        let tractsFeatureLayer = new FeatureLayer(appConfig.getConfig().tractsUrl);
        tractsFeatureLayer.addAttachment(objectId, form, function(success) {
          if (success.attachmentId == null) {
            alert('Error uploading image.  Please try again.');
          }
          _refreshLayers();
        }, function() {
          alert('Error uploading image.  Please try again.');
        });
      });
    }

    function _refreshLayers() {
      maps.refreshDynamicLayer();
      // parcelsLayer.clearSelection();
      // parcelsLayer.clear();
      // parcelsLayer.refresh();
      // tractsLayer.refresh();
    }

    function _processFeatures(tractNumber, proSaleType, lastLsDate, m_comments) {
      let allUpdatedFeatures = [];
      for (let i = 0; i < selectedFeatures.length; i++) {
        let updateFeature = {};
        updateFeature.attributes = {
          'OBJECTID': selectedFeatures[i].attributes.OBJECTID,
          'Tract': tractNumber,
          'ProposedSaleType': proSaleType,
          'Last_LS_date': lastLsDate,
          'm_comments': m_comments
        };
        allUpdatedFeatures.push(updateFeature);
      }
      return allUpdatedFeatures;
    }

    // calculate the new tract centroid and the direction hyperlink fields
    function _calcCentroidAndLinks(geometry, attributes) {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/GeometryService',
        'esri/tasks/ProjectParameters',
        'esri/SpatialReference'
      ], function(
        GeometryService,
        ProjectParameters,
        SpatialReference
      ) {
        let centroid = geometry.getCentroid();
        // project the geometry to NAD 83 lat/long coordinates
        let gsvc = new GeometryService(appConfig.getConfig().geometryService);
        let params = new ProjectParameters();
        params.geometries = [centroid];
        params.outSR = new SpatialReference(4269);
        gsvc.project(params, function(result) {
          let lat = result[0].y;
          let longitude = result[0].x;
          attributes.latitude = lat;
          attributes.longitude = longitude;
          attributes.mapslos = 'maps://maps.apple.com/maps?daddr=' + lat + ',' + longitude + '&amp;ll=';
          attributes.httpIos = 'https://maps.apple.com/maps?daddr=' + lat + ',' + longitude + '&amp;ll=';
          attributes.httpOther = 'http://maps.google.com?daddr=' + lat + ',' + longitude + '&amp;ll=';
          d.resolve(attributes);
        });
      });
      return d.promise;
    }

    function getDomainValue(field, code) {
      let domainValues = _.find(fields, {
        'name': field
      }).domain.codedValues;
      return _.find(domainValues, {
        'code': code
      });
    }

    function _formatDate(date) {
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }

    // crazy function but seems to work for bulk editing....
    function _formatBulkFeatures(bulkAttributes, selected, selField) {
      let bulkTracts = [];
      let bulkFeature = _removeNull(bulkAttributes);
      for (let id in allTracts) {
        let oneTract = allTracts[id].attributes;
        // console.log(oneTract);
        for (let field in bulkFeature) {
          // console.log(field, bulkFeature);
          if (oneTract.hasOwnProperty(field)) {
            if (selected[oneTract[selField]] === true) {
              // console.log('Has property and matched PIN ', selected, oneTract, bulkFeature[field]);
              if (bulkFeature[field] != null && typeof bulkFeature[field] === 'object') {
                oneTract[field] = _formatDataBaseDate(_formatDate(bulkFeature[field].date));
              } else {
                oneTract[field] = bulkFeature[field];
              }
            }
          }
        }
        // check if the bulk edited fields to see if the parcel has the field, if not remove it from the object and format the object for submission to ArcGIS
        let bulkTract = {
          attributes: _removeNonBulkFields(bulkFeature, angular.copy(oneTract))
        };
        // console.log(bulkTract);
        if (selected[bulkTract.attributes[selField]] === true) {
          bulkTracts.push(bulkTract);
        }
      }
      return bulkTracts;
    }

    function _removeNull(feature) {
      for (let field in feature) {
        if (feature.hasOwnProperty(field)) {
          if (feature[field] === null || feature[field] === '') {
            delete feature[field];
          }
        }
      }
      return feature;
    }

    function _removeNonBulkFields(bulkFeature, oneTract) {
      let donotDelete = ['PIN', 'OBJECTID', 'GlobalID', 'Tract'];
      for (let field in oneTract) {
        if (bulkFeature.hasOwnProperty(field) === false) {
          if (donotDelete.indexOf(field) < 0) {
            delete oneTract[field];
          }
        }
      }
      return oneTract;
    }

    function _formatDataBaseDate(inDate) {
      let parts = inDate.split('/');
      let mydate = new Date(parts[2], parts[0] - 1, parts[1]);
      // mydate.setHours(mydate.getHours() - 7);
      // console.log(mydate);
      mydate = mydate.toISOString().slice(0, 19).replace('T', ' ');
      return mydate;
    }

  }
})();
